export const MUNICIPAL_PROPERTY_TYPE_LIST = [
    "ADMINISTRATION",
    "SCHOOL",
    "DAYCARE",
    "BUILDING_YARD",
    "FIRE_STATION",
    "SPORTS_FACILITY",
    "SWIMMING_POOL",
    "CULTURAL_FACILITY",
    "SUPPLY_INFRASTRUCTURE",
    "OTHER",
];
